import React from "react";
import home from "../assets/rank10.webp"
import StatsSection from "./HomePage1";
import { FaPhoneAlt } from "react-icons/fa";
import Homepage2 from "./HomePage2";
import CircleFeatures from "./circlerimages";
import AcademicPrograms from "./rankridgegrades";
import ImageCarousel from "./image_carousel";
import { nav } from "framer-motion/m";
import { useNavigate } from "react-router-dom";
import CommonImageSlider from "./comandata";
import { acadmicImages, homeImages } from "./data";
import SeoMeta from "./seometa";
import { AboutHeader } from "./aboutheader";
import ReviewsSection from "./ReviewsSection";
import ReviewsTextOnly from "./ReviewsTextOnly";
import BlogList from "./BlogList";

const seopages = {
    title: "Best Schools in Hyderabad With IIT-JEE & NEET Foundation | Rankridge Schools KPHB",
    description:
      " Rankridge International School – Hyderabad’s leading K–12 institution offering Pre-Primary to Grade 12 education with CBSE & State Board, IIT-JEE & NEET foundation, and holistic development. Admissions open now.",
    keywords: " best schools in hyderabad, rankridge school, rankridge international school, cbse schools in hyderabad, state board schools in hyderabad, pre primary school hyderabad, top primary school hyderabad, best secondary school hyderabad, best intermediate college hyderabad, iit jee foundation hyderabad, neet foundation hyderabad, competitive exam coaching hyderabad, best junior college hyderabad, mpc with iit jee coaching, bipc with neet coaching, best school near me, hyderabad schools admissions, best private schools hyderabad, cbse and state board schools, holistic education hyderabad",
    canonical_path: "https://rankridgeschools.com",
    og_description: "",
    og_image: "",
  };

 function Homepage() {
const navigate=useNavigate()
 const closeMenu = () =>{
navigate("/form")
    window.scrollTo({top:0,behavior:"smooth"})
   } 

  return (
    <div>
                 <h1 className="text-3xl text-center font-bold">Best Schools in Hyderabad for IIT-JEE & NEET Foundation</h1>

     <section style={{marginTop:"-20px"}} className="bg-white  px-4 sm:px-8 md:px-20 xl:px-40 flex flex-col-reverse md:flex-row items-center justify-between gap-1">
     

      <div className="w-full md:w-1/2 max-w-xl text-center md:text-left space-y-5">
        <h2 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-bold leading-tight mt-10">
          Beyond <span className="text-[#20b2aa]">Books</span> <br />
          Building Character, Creativity
         &<span className="text-[#20b2aa]">  Capability</span>
        </h2>

        <p className="text-gray-600 text-green-900 sm:text-lg md:text-base xl:text-lg capitalize ">
         Empowering Young Minds with a World-Class Learning platform and dynamic
 resources  to curiosity, creativity & academic excellence.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
         <a href="tel:+919959303873" className="flex items-center justify-center">
  <button className="flex font-roboto items-center justify-center gap-2 bg-[#20b2aa] text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
    <FaPhoneAlt />
    Call Now +91 99 59 303 873
  </button>
</a>

          <button onClick={closeMenu} className="bg-green-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition">
          ENQUIRE NOW
          </button>
         
        </div>

      </div>

      <div className="w-full md:w-1/2 justify-center bg-[#20b2aa] pe-2 ps-2 mt-10">
{/* 
        <img src={home}alt="Student"
          className="w-full max-w-md sm:max-w-lg md:max-w-md lg:max-w-lg xl:max-w-xl h-auto object-contain rounded-xl"/>
     */}
                       <h6  className="text-2xl text-center text-black font-extrabold mt-10">Educating Minds <br></br> That will Lead  the World </h6>


        <CommonImageSlider images={homeImages} />

      {/* <ImageCarousel /> */}
      </div> 

    </section>
<section className="mt-2">
 {/* <AboutHeader  /> */}

  <AcademicPrograms status={true} />
</section>

    <section>
      <CircleFeatures />
    </section>
    {/* <StatsSection /> */}
    <Homepage2/>
    <BlogList />
    <ReviewsTextOnly />

        <SeoMeta seopages={seopages} />
    </div>
  );
}
export default Homepage